// extracted by mini-css-extract-plugin
module.exports = {"title":"Customization_title__i_X_1","customization":"Customization_customization__EzKVs","description":"Customization_description__BG7qH","tag":"Customization_tag__jrkxq"};